// extracted by mini-css-extract-plugin
module.exports = {"customLink":"NiceButton_customLink__CwsHT"};